import { useState } from 'react';
import { Person as PersonIcon } from '@mui/icons-material';
import ImageLightbox from './ImageLightbox';

type DriverProfilePictureProps = {
    fullName: string;
    profilePictureUrl: string | null;
};

const DriverProfilePicture = ({ fullName, profilePictureUrl }: DriverProfilePictureProps) => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const imageAlt = `Foto de perfil de ${fullName || 'conductor'}`;

    return (
        <div>
            <button
                type='button'
                onClick={() => profilePictureUrl && setLightboxOpen(true)}
                disabled={!profilePictureUrl}
                className='w-28 h-28 rounded-2xl overflow-hidden bg-gray-100 flex-shrink-0 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 disabled:cursor-default cursor-pointer shadow-sm transition-shadow hover:shadow-md'
                aria-label={profilePictureUrl ? 'Ver foto en grande' : undefined}
            >
                {profilePictureUrl ? (
                    <img
                        src={profilePictureUrl}
                        alt={imageAlt}
                        className='w-full h-full object-cover'
                        referrerPolicy='no-referrer'
                    />
                ) : (
                    <PersonIcon sx={{ fontSize: 56 }} className='text-gray-400' />
                )}
            </button>
            {profilePictureUrl && (
                <ImageLightbox
                    open={lightboxOpen}
                    onClose={() => setLightboxOpen(false)}
                    imageUrl={profilePictureUrl}
                    alt={imageAlt}
                />
            )}
        </div>
    );
};

export default DriverProfilePicture;
